import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function reasonNotValid(reasons: string[]): ValidatorFn {
  return (control: AbstractControl<string | null, string>): ValidationErrors | null => {
    const value = control.value;
    if (!reasons.includes(value)) {
      return { reasonNotValid: true };
    }
    return null;
  };
}
